<template>
  <div class="mb-4 ">
    <CRow>
      <CCol class="text-center">
        <p class="h4 "> {{ $t('idp.title') }} </p>
        <p class="h5 "> {{ $t('idp.round') }} : {{ this.$store.getters['idp/idp'].year }} </p>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <label class="font-weight-bold">ส่วนที่ 1 : ข้อมูลส่วนบุคคล</label>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="12">
        <label ><samp class="font-weight-bold">ชื่อ-นามสกุล :  </samp> {{ getUserInfo("prefix") }} {{ getUserInfo("firstName") }} {{ getUserInfo("lastName") }} </label>
      </CCol>
      <CCol col="8">
        <label  ><samp class="font-weight-bold"> ตำแหน่ง :  </samp>  {{ this.$store.getters['idp/idp'].position.name.title.filter(obj => { return (obj.key === lang) })[0].value  }}</label>
      </CCol>
      <CCol col="4">
        <label  ><samp class="font-weight-bold"> อายุงาน :  </samp> {{ calculateWorkDuration(this.$store.getters['idp/idp'].accounts.positions,null) }}</label>
      </CCol>
      <CCol col="12">
        <label  ><samp class="font-weight-bold">หน่วยงานที่สังกัด : </samp>  {{ this.$store.getters['idp/idp'].accounts.positions[this.$store.getters['idp/idp'].accounts.positions.length-1].agency.title.filter(obj => { return (obj.key === lang) })[0].value  }}</label>
      </CCol>
      <CCol col="12">
        <label  ><samp class="font-weight-bold">ผู้บังคับบัญชาชั้นต้น : </samp> {{ this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.prefix.filter(obj => { return (obj.key === lang) })[0].value }} {{ this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.firstName.filter(obj => { return (obj.key === lang) })[0].value }}  {{ this.$store.getters['idp/idp'].assessor.accounts.accounts.userinfo.lastName.filter(obj => { return (obj.key === lang) })[0].value }} </label>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <label class="font-weight-bold">ส่วนที่ 2 :  แผนพัฒนาบุคลากรรายบุคคล (ทำร่วมกับผู้บังคับบัญชาชั้นต้น)</label>
      </CCol>
    </CRow>
    <CRow>
      <label class="font-weight-bold ml-3">คำชี้แจง</label>
      <CCol>
        <CRow>
          <CCol>
            <label>1. ให้ผู้รับกำรพัฒนำระบุ (1) สมรรถนะและ/หรือทักษะที่ท่ำนต้องกำรพัฒนำ (2) พฤติกรรม/ผลลัพธ์ที่คำดหวัง (3) วิธีกำรพัฒนำ (4) ระยะเวลำ และ (5) งบประมำณ
              จำกที่ได้ตกลงร่วมกันกับผู้บังคับบัญชำชั้นต้น </label>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <label > 2. ให้ผู้บังคับบัญชำชั้นต้นติดตำมพฤติกรรม หรือผลลัพธ์ที่ได้หลังจำกผู้รับกำรพัฒนำเข้ำรับกำรพัฒนำตำมแผนพัฒนำรำยบุคคล และแจ้งผลกำรพัฒนำในส่วนที่ 3 </label>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import moment from "moment/moment";

export default {
  name: 'IDPProfile',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },


  },

  data: function () {
    return {

    }
  },

  mounted() {
  },

  created() {

  },
  beforeDestroy() {

  },

  methods: {
    getUserInfo(key) {
      return this.$store.getters['idp/idp']?.accounts?.accounts?.userinfo[key]?.find((obj) => obj.key === this.lang)?.value || "";
    },

    calculateWorkDuration(startDate, endDate) {

      const start = moment(startDate[startDate.length-1].startDate);
      const end = endDate ? moment(endDate) : moment(); // หากไม่มี endDate ให้ใช้วันที่ปัจจุบัน

      const years = end.diff(start, 'years');
      start.add(years, 'years');

      const months = end.diff(start, 'months');
      start.add(months, 'months');

      const days = end.diff(start, 'days');

      return `${years} `+this.$t('year')+` ${months} `+this.$t('months')+` ${days} `+this.$t('days');
    }


  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {
    lang(value){

    }
  }
}
</script>
<style>

</style>
